import {
  Globe, Target, TrendingUp,
  GraduationCap, Search,
  BookMarked, Microscope, Building2
} from 'lucide-react';

export const atAGlance = [
  { label: 'Program Name', value: 'Doctor of Humanitarian Action & Development' },
  { label: 'Duration', value: '3 Years' },
  { label: 'Mode of Delivery', value: '100% Online' },
  { label: 'Program Structure', value: '8 Courses + Doctoral Dissertation' },
  { label: 'Full Program Fee', value: 'USD 10,800' },
  { label: 'Scholarship', value: '90% available for Afro-Asia students' },
  { label: 'Learning Format', value: 'Flexible online study' },
  { label: 'Final Component', value: 'Doctoral Dissertation' },
  { label: 'Documents Issued', value: 'Doctoral Degree Certificate and Academic Transcript, subject to successful completion' },
];

export const whoIsFor = [
  'Senior humanitarian and development professionals',
  'Researchers and policy practitioners',
  'Aspiring academics and educators',
  'Emerging thought leaders',
  'Humanitarian managers and senior practitioners',
  'Development-sector professionals seeking advanced research capacity',
  'Professionals interested in policy, advocacy, leadership, and applied research',
  'Learners seeking to contribute to humanitarian knowledge, systems, and practice'
];

export const entryRequirements = [
  'Master\'s degree in a relevant field',
  'Relevant professional experience',
  'Proficiency in English',
  'Demonstrated research interest and academic commitment'
];

export const whyChooseFeatures = [
  {
    icon: Microscope,
    title: 'Research-Focused Curriculum',
    description: 'The curriculum is connected to contemporary humanitarian and development challenges and supports advanced academic and professional inquiry.'
  },
  {
    icon: BookMarked,
    title: 'Doctoral Dissertation',
    description: 'The program includes a doctoral dissertation designed to support advanced research, analysis, and knowledge contribution.'
  },
  {
    icon: Globe,
    title: 'Flexible Online Delivery',
    description: 'The program is delivered fully online, supporting experienced professionals balancing study with professional responsibilities.'
  },
  {
    icon: Target,
    title: 'Global Perspective',
    description: 'The program is informed by international debates, diverse contexts, and field realities across humanitarian and development settings.'
  },
  {
    icon: TrendingUp,
    title: 'Leadership & Policy Engagement',
    description: 'The program strengthens leadership, strategic thinking, policy engagement, and applied research capacity for practitioners, researchers, and emerging thought leaders.'
  }
];

export const learningOutcomes = [
  'Conduct independent, original research in humanitarian and development studies',
  'Critically analyze humanitarian policies and their global implications',
  'Develop innovative responses to emerging humanitarian and development challenges',
  'Lead strategic initiatives in humanitarian organizations, academia, and policy settings',
  'Contribute to academic scholarship and professional knowledge in humanitarian studies',
  'Design and influence large-scale humanitarian programs, systems, and policies',
  'Mentor the next generation of humanitarian professionals and researchers',
  'Engage in high-level policy dialogue at national, regional, and international levels'
];

export const courses = [
  {
    number: '01',
    title: 'Advanced Theories in Humanitarian Action',
    duration: '3 Months',
    description: 'This course explores advanced theoretical frameworks shaping humanitarian action, humanitarian thought, ethics, and contemporary debates.',
    topics: [
      'Critical theories in humanitarianism',
      'Postcolonial perspectives on aid and development',
      'Political economy of humanitarian action',
      'Humanitarian ethics and moral philosophy',
      'Emerging paradigms in humanitarian thought'
    ]
  },
  {
    number: '02',
    title: 'Research Methods in Humanitarian Studies',
    duration: '3 Months',
    description: 'This course develops advanced understanding of research approaches used in humanitarian and development contexts.',
    topics: [
      'Qualitative research methods',
      'Quantitative research methods',
      'Mixed methods approaches',
      'Research in conflict and crisis settings',
      'Ethical considerations in humanitarian research'
    ]
  },
  {
    number: '03',
    title: 'Policy Analysis & Advocacy in Development',
    duration: '3 Months',
    description: 'This course examines how policy analysis and advocacy influence humanitarian and development outcomes.',
    topics: [
      'Policy analysis frameworks',
      'Evidence-based policy making',
      'Advocacy strategies and campaigns',
      'Engaging with policy makers',
      'Measuring policy impact'
    ]
  },
  {
    number: '04',
    title: 'Advanced International Humanitarian Law',
    duration: '3 Months',
    description: 'This course examines advanced issues in International Humanitarian Law and its application in modern conflict settings.',
    topics: [
      'Evolution of IHL in modern conflicts',
      'Non-state armed groups and IHL',
      'Accountability mechanisms and tribunals',
      'Emerging challenges: cyber warfare, autonomous weapons',
      'IHL implementation and enforcement'
    ]
  },
  {
    number: '05',
    title: 'Strategic Leadership in Humanitarian Organizations',
    duration: '3 Months',
    description: 'This course focuses on strategic leadership, organizational development, governance, and decision-making in humanitarian contexts.',
    topics: [
      'Strategic planning and organizational development',
      'Change management in humanitarian contexts',
      'Board governance and stakeholder relations',
      'Crisis leadership and decision-making',
      'Building organizational resilience'
    ]
  },
  {
    number: '06',
    title: 'Quantitative & Qualitative Research Design',
    duration: '3 Months',
    description: 'This course strengthens advanced research design capacity for doctoral-level inquiry.',
    topics: [
      'Advanced statistical analysis',
      'Longitudinal study design',
      'Comparative case study methods',
      'Grounded theory and phenomenology',
      'Data visualization and presentation'
    ]
  },
  {
    number: '07',
    title: 'Ethics in Humanitarian Research & Practice',
    duration: '3 Months',
    description: 'This course examines ethical responsibilities in humanitarian research, practice, and decision-making.',
    topics: [
      'Research ethics in vulnerable populations',
      'Institutional Review Board processes',
      'Ethical frameworks for humanitarian action',
      'Balancing competing ethical obligations',
      'Professional ethics and integrity'
    ]
  },
  {
    number: '08',
    title: 'Global Health & Humanitarian Response',
    duration: '3 Months',
    description: 'This course explores the relationship between global health, crisis response, equity, and humanitarian systems.',
    topics: [
      'Health systems in humanitarian emergencies',
      'Epidemic and pandemic response',
      'Mental health in humanitarian contexts',
      'Health equity and access',
      'One Health approaches'
    ]
  },
  {
    number: '09',
    title: 'Doctoral Dissertation',
    duration: '12 Months',
    description: 'The doctoral dissertation allows learners to conduct advanced research on a relevant humanitarian or development topic.',
    topics: [
      'Dissertation proposal development',
      'Research methodology application',
      'Data collection and analysis',
      'Faculty mentorship and feedback',
      'Final dissertation submission'
    ],
    isDissertation: true
  }
];

export const careerPathways = {
  leadership: {
    title: 'Senior Leadership & Strategy',
    icon: Building2,
    roles: ['Humanitarian Program Director', 'Country Director / Deputy Country Director', 'Director of Strategy and Partnerships', 'Senior Advisor in Humanitarian Affairs', 'Institutional Development Lead']
  },
  research: {
    title: 'Research, Policy & Advisory',
    icon: Search,
    roles: ['Humanitarian Policy Advisor', 'Research Fellow / Senior Research Associate', 'Policy and Advocacy Specialist', 'Humanitarian Analyst', 'Strategic Planning and Learning Advisor']
  },
  academic: {
    title: 'Academic & Knowledge Leadership',
    icon: GraduationCap,
    roles: ['Lecturer / Academic Faculty Member', 'Doctoral Researcher / Scholar', 'Curriculum and Training Lead', 'Academic Program Coordinator', 'Humanitarian and Development Scholar']
  }
};

export const admissionsSteps = [
  { step: 1, title: 'Application Submission', description: 'Applicants complete the online application form and submit the required information.' },
  { step: 2, title: 'Document Review', description: 'The Admissions Team reviews submitted documents, eligibility, professional background, and research readiness.' },
  { step: 3, title: 'Admissions Offer', description: 'Successful applicants may receive an admissions offer and scholarship confirmation.' },
  { step: 4, title: 'Tuition Payment', description: 'Applicants complete the required tuition payment to confirm admission.' },
  { step: 5, title: 'Program Begins', description: 'Confirmed students receive program access and begin their online learning pathway.' }
];

export const faqs = [
  { question: 'Is the program fully online?', answer: 'Yes. The program is delivered entirely online and is designed to be accessible to learners across different locations.' },
  { question: 'Who is eligible for the Afro-Asia Scholarship?', answer: 'The scholarship is available to eligible applicants from Africa and Asia who demonstrate commitment to humanitarian and development work.' },
  { question: 'What is the full program fee?', answer: 'The full tuition for the Doctor of Humanitarian Action & Development is USD 10,800 for the entire 3-year program (USD 3,600 per year). Eligible Afro-Asia students may apply for our 90% scholarship.' },
  { question: 'What documents are awarded upon completion?', answer: 'Eligible graduates may receive a Doctoral Degree Certificate and Academic Transcript upon successful completion of the program and fulfilment of all academic and research requirements.' },
  { question: 'Can working professionals apply?', answer: 'Yes. The program is designed to support experienced professionals seeking flexible online study alongside professional responsibilities.' },
  { question: 'Do I need prior humanitarian experience to apply?', answer: 'Applicants are generally expected to have relevant academic preparation, professional experience, and a demonstrated interest in humanitarian or development work.' },
  { question: 'Is a master\'s degree required?', answer: 'Applicants are generally expected to hold a master\'s degree in a relevant field or demonstrate equivalent academic and professional preparation, subject to admissions review.' },
  { question: 'Is there a dissertation?', answer: 'Yes. The program includes a doctoral dissertation designed to support advanced inquiry, applied research, and knowledge contribution.' },
  { question: 'How long does the program take?', answer: 'The program is designed to be completed over 3 years.' },
  { question: 'How do I apply?', answer: 'Applicants must complete the application form, submit the required documents, and undergo admissions review by the Institute.' }
];
